import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/CommentSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/PopUpButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/TabbedNewsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/modules/Advertisement.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/modules/SanitizedContent.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
